// frontend/src/utils/api.js

// Lê a mensagem de erro de uma resposta da API. O backend devolve
// { message }; se o corpo não for JSON (ex.: erro do nginx), usa o texto padrão.
export async function readError(res, fallback) {
  const data = await res.json().catch(() => null);
  return (data && (data.message || data.error)) || fallback;
}

// Se a resposta não for ok, lança Error com a mensagem do servidor.
export async function assertOk(res, fallback) {
  if (!res.ok) throw new Error(await readError(res, fallback));
  return res;
}
